function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icono-cc-azul",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "todo-icon.9ad2e36b-2",
  fill: "#000098",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "todo-icon.9ad2e36b"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 13,
  cy: 13,
  r: 13
}))), /*#__PURE__*/React.createElement("path", {
  d: "M8.71293119,18 C7.7668245,18 7,18.7281739 7,19.6265377 L7,20 L18,20 L18,19.6265377 C18,18.7281739 17.2330497,18 16.286943,18 L8.71293119,18 Z",
  id: "Fill-24",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,12.0000603 C8,9.18372242 10.1985789,7 13.0342336,7 C14.3081424,7 15.39736,7.40820508 16.1574824,7.97971629 C16.5684873,8.28571945 16.7533,8.61233172 16.7533,9.00004821 C16.7533,9.51021417 16.3424164,9.91841924 15.7671067,9.91841924 C15.520528,9.91841924 15.2534416,9.81645837 14.965726,9.61229557 C14.4520609,9.22445856 13.7945987,8.97968014 13.0752491,8.97968014 C11.3286907,8.97968014 10.0135235,10.3061357 10.0135235,12.0000603 C10.0135235,13.6733757 11.3286907,15.0204404 13.0958782,15.0204404 C13.9587822,15.0204404 14.6986396,14.7143167 15.2534416,14.2245188 C15.458762,14.020356 15.7671067,13.8571704 16.07533,13.8571704 C16.6095029,13.8571704 17,14.2857436 17,14.8162776 C17,15.061297 16.8972184,15.3264435 16.6095029,15.6530558 C15.82863,16.489834 14.4520609,17 13.0342336,17 C10.1985789,17 8,14.7959095 8,12.0000603 Z",
  id: "Fill-26",
  fill: "#FF6A13"
})));

function SvgTodos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono cc azul") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodos);
export default __webpack_public_path__ + "static/media/todos.34824325.svg";
export { ForwardRef as ReactComponent };